export enum ChatMessageRoleEnum {
  Assistant = 'ASSISTANT',
  User = 'USER',
}
